import React from "react";
import { Redirect } from "react-router-dom";

import Loader from "components/Loader";
import Text from "components/Text";
import styles from "components/projects/requirement/Process.scss";
import { useAnswerContext } from "contexts/answerContext";
import useParam from "hooks/useParam";
import { useRequirementBySlug } from "queries/requirements";
import { getRequirementApplicationByRequirementID } from "reducers/projects";
import { isPayable } from "reducers/requirementApplications";

const Process = () => {
  const { record: project } = useAnswerContext();
  const requirementSlug = useParam("requirementSlug");
  const { data: requirement, isLoading } = useRequirementBySlug(requirementSlug);
  if (isLoading) return <Loader />;
  const application = getRequirementApplicationByRequirementID(project, requirement.id);

  if (!isPayable(application)) return <Redirect to={`/projects/${project.id}/apply`} />;

  return (
    <main role="main">
      <div className={styles.container}>
        <Loader large />
        <div className={styles.description}>
          <Text t="projects.requirement.payment.verifying" />
        </div>
      </div>
    </main>
  );
};

export default Process;
